import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledLink = styled.button`
  opacity: 0;
  width: 250px;
  height: 50px;
  background: none;
  border: 2px solid ${({ theme }) => theme.color.first};
  box-sizing: border-box;
  border-radius: 50px;
  position: relative;
  color: ${({ theme }) => theme.color.first};
  font-size: ${({ theme }) => theme.font.size.xs};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  font-family: Raleway, sans-serif;
  line-height: 10px;
  cursor: pointer;
  padding: 1.1rem 2rem 0.875rem;
  overflow: hidden;
  user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  margin: 15px 0;
  outline: none;
  text-align: center;
  z-index: 1;
  transition: all 0.7s ease;
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.color.first};
    position: absolute;
    transition: all 0.7s ease;
    top: 0;
    left: -100%;
    box-sizing: border-box;
    border-radius: 50px;
    z-index: -1;
  }
  &:hover {
    color: ${({ theme }) => theme.color.second};
    background-color: ${({ theme }) => theme.color.first};
    &:before {
      transform: translateX(100%);
    }
  }

  ${({ theme }) => theme.mq.tablet} {
    width: 320px;
  }
  ${({ theme }) => theme.mq.desktop} {
    width: 420px;
  }
`;

const HeroButton = React.forwardRef(
  ({ className, id, children, ...props }, ref) => (
    <StyledLink ref={ref} id={id} className={className} {...props}>
      {children}
    </StyledLink>
  )
);

HeroButton.displayName = 'HeroButton';

HeroButton.defaultProps = {
  className: '',
};

HeroButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
};

export default HeroButton;
